import React, { useState, useEffect } from "react";
import teamImage from "./assets/team.jpg";
import img1 from "./assets/leader.jpg";
import img2 from "./assets/teamper.jpg";
import img3 from "./assets/strategy.jpg";
import img4 from "./assets/change.jpg";
import img5 from "./assets/multi.jpg";
import card from "./assets/card.jpg";
import "./Home.css";
import { Link } from "react-router-dom";
import NavBar from "./components/NavBar";
import astraZenecaLogo from "./assets/astrazeneca.png"
import microlandLogo from './assets/microland.png';
import carrierLogo from './assets/carrier.png';
import hsbcLogo from './assets/hsbc.png';
import mahindraUniversityLogo from './assets/mahindra_university.svg';
import lumenLogo from './assets/lumen.png';
import optumLogo from './assets/optum.png';
import pegaLogo from './assets/pega.png';
import techMahindraLogo from './assets/tech_mahindra.png';
import schneiderLogo from './assets/schneider_electric.png';
import allianzLogo from './assets/allianz.png';
import nalsarLogo from './assets/nalsar.png';
import Hero from "./assets/Hero.jpg";
import Who from "./assets/Who.jpeg"
import Dnb from "./assets/dandb.png";
import Tao from "./assets/tao.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink } from 'react-router-hash-link';
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import SEO from "./components/SEO";




const clientLogos = [
  { src: allianzLogo, alt: "Allianz" },
  { src: astraZenecaLogo, alt: "AstraZeneca" },
  { src: carrierLogo, alt: "Carrier" },
  { src: Dnb, alt: "Dnb" },
  { src: hsbcLogo, alt: "HSBC" },
  { src: lumenLogo, alt: "Lumen" },
  { src: mahindraUniversityLogo, alt: "Mahindra University" },
  { src: microlandLogo, alt: "Microland" },
  { src: nalsarLogo, alt: "Department of Management Studies, NALSAR" },
  { src: optumLogo, alt: "Optum" },
  { src: pegaLogo, alt: "Pega" },
  { src: schneiderLogo, alt: "Schneider Electric" },
  { src: Tao, alt: "Tao" },
  { src: techMahindraLogo, alt: "Tech Mahindra" },
];



const trustFeatures = [
  {
    icon: '',
    title: 'Fortune 500 Trust',
    description: 'Leading multinational corporations rely on our expertise to upskill their workforce in critical technology areas, driving innovation and competitive advantage.'
  },
  {
    icon: '',
    title: 'Academia Integration',
    description: 'Our programs are developed in collaboration with leading global academia, ensuring cutting-edge, research-backed curriculum for future leaders.'
  },
  {
    icon: '',
    title: 'Industry-Ready Skills',
    description: 'We focus on practical, hands-on training tailored to current industry demands, making teams immediately productive and market-ready.'
  },
];


// --- The Main Component ---
const ClientTrustSection = () => {
  return (
    <div className="client-trust-container">
      <SEO
        title="Home"
        description="RTS Techsol helps organizations Rise to Scale with technology training, leadership development, talent acquisition, cloud labs, and advisory services."
        path="/"
      />


      {/* Trust Features Grid */}
      <div className="trust-features-grid">
        {trustFeatures.map((feature, index) => (
          <div key={index} className="trust-feature-card">
            <div className="trust-feature-icon">{feature.icon}</div>
            <h3 className="trust-feature-title">{feature.title}</h3>
            <p className="trust-feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
function Home() {

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) {
      setMessage('Please enter a valid email address.');
      return;
    }

    setIsLoading(true);
    setMessage('');

    try {

      const response = await fetch('/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email }),
      });

      if (response.ok) {
        setMessage(' Subscribed successfully! Check your inbox for confirmation.');
        setEmail('');
      } else {
        const errorData = await response.json();
        setMessage(`Subscription failed: ${errorData.message || 'Server error.'}`);
      }
    } catch (error) {
      console.error('Subscription Error:', error);
      setMessage('An unexpected network error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  const testimonials = [
    { text: "Bringing together senior leaders from across TAO India for the Mastering Customer Experience through Leadership Excellence leadership training program was an experience in itself—one that reminded me just how powerful learning can be when done together. ", author: "Raghu Ram Burra, Vice President & Delivery Head - TAO Digital", },
    { text: "As an HR leader, I value partners who bring reliability, ownership, and genuine partnership — RTS TechSol has consistently demonstrated all of these. It’s been a strong collaboration, and we look forward to building more future-focused learning experiences together.", author: "Sangeet Nyapati, Country HR Manager - D&B", },
    { text: "Thank you for delivering an outstanding training program for our new managers. The team’s thoughtful approach transformed an initial concept into a comprehensive experience that addressed every essential aspect of leadership for those at the beginning of their journey. We are already witnessing significant growth among our emerging leaders.", author: "Tulasi Pochampalli, Head HR - APAC, Envoy Global", },

  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);
  return (
    <div className="home-page">
      <NavBar />
      <section className="hero-section">
        <div className="container">
          <div className="hero-grid">

            {/* Left Column: Content */}
            <div className="hero-content">
              <h1 className="hero-title"> Rise to Scale </h1>
              <p className="hero-subtitle">
                Empowering individuals and organizations to unlock their full potential, Rise to Scale is a holistic talent transformation journey designed to elevate capability, performance, and impact.
              </p>

              {/* Action Buttons */}
              <div className="hero-actions">
                <Link to="/contact" className="btn primary-btn"> Get in Touch </Link>
                <Link to="/services" className="btn secondary-btn">Services </Link>
              </div>
            </div>
            <div className="hero-image-container">
              <img src={Hero} alt="Woman working on advanced tech machinery" className="hero-image" />
            </div>

          </div>
        </div>
      </section>
      <ClientTrustSection />
      <div className="vision-section">
        <div className="vision-left"> {" "} <h1>Our Vision in Action</h1>{" "} </div>
        <div className="vision-right">
          <p> To empower organizations to rise to scale by delivering innovative, future-ready workforce development solutions that drive transformation, accelerate growth, and create lasting impact. </p>
        </div>
      </div>
      <div className="who-section">
        <h1 className="section-title-center">Who We Are</h1>

        <div className="who-container">


          <div className="who-image">

            <img src={teamImage} alt="Our Expert Team" />
            <img src={Who} alt="Our Expert Team" />
          </div>


          <div className="who-content">
            <h2 className="content-heading">We make a difference, together.</h2>

            <p>
              RTS Techsol is where innovation meets excellence in technology services. We are a trusted strategic partner helping organizations navigate the complexities of modern business transformation. Our strength lies in combining deep domain expertise with forward-thinking training solutions to help enterprises stay agile, scalable, and competitive in a rapidly changing world.
            </p>

            <h2 className="content-heading">Enabling Sustainable Transformation</h2>
            <p>
              At RTS Techsol, we go beyond addressing current challenges — we enable sustainable transformation. Our comprehensive offerings include:
            </p>


            <ul className="professional-list">
              <li>
                <span className="bullet-icon">➤</span> Technology Solutions that enhance efficiency, scalability, and agility.
              </li>
              <li>
                <span className="bullet-icon">➤</span> Training and Talent Development programs that prepare teams for future demands.
              </li>
              <li>
                <span className="bullet-icon">➤</span> Strategic Consulting that aligns people, process, and technology for measurable outcomes.
              </li>
              <li>
                <span className="bullet-icon">➤</span> Leadership programs that elevate executive potential, build & accelerate transformations and sustainable growth.
              </li>
            </ul>

            <p className="closing-statement">
              Together, we design programs for businesses and professionals to thrive for greater good.
            </p>

            <Link to="/About" className="btn secondary-btn">Get to Know Us </Link>
          </div>

        </div>
      </div>
      <div className="solutions-section">
        <div className="solutions-header">
          <h2>SOLUTIONS</h2>
          <h1>Designed For You, With You.</h1>
        </div>
        <div className="solution-card">
          <div className="solution-image">
            <img src={img1} alt="Leadership Development" />
          </div>
          <div className="solution-content">
            <h1>Coaching Leaders at Every Level</h1>
            <p> Our leadership development goes beyond traditional training. We design experiential and value-driven programs that align with your organization’s culture while unlocking the potential of emerging and established leaders alike. </p>

            <Link to="/services" className="btn"> Know More </Link>
          </div>
        </div>
        <div className="solution-card reverse">
          <div className="solution-image">
            <img src={img2} alt="Team Performance" />
          </div>
          <div className="solution-content">
            <h1>Team Synergy</h1>
            <p> Empowering teams through custom solutions that build synergy across functions, strengthen collaboration, and transform challenges into opportunities for lasting success. </p>
            <Link to="/services" className="btn"> Know More </Link>
          </div>
        </div>
        <div className="solution-card">
          <div className="solution-image">
            <img src={img3} alt="Strategy Implementation" />
          </div>
          <div className="solution-content">
            <h1>Strategy at Work</h1>
            <p> Adopting an organisation centric strategy with elements of human-centric approach, we create meaningful tranformational trainings with practioner mindset. </p>
            <Link to="/services" className="btn"> Know More </Link>
          </div>
        </div>
        <div className="solution-card reverse">
          <div className="solution-image">
            <img src={img4} alt="Change Leadership" />
          </div>
          <div className="solution-content">
            <h1>Agile Leadership in Action</h1>
            <p> Strategic, programmatic methods that drive transformation—guiding you through effective change management and leadership enablement. Our approach empowers teams to adapt, collaborate, and confidently lead future change with agility and purpose. </p>
            <Link to="/services" className="btn"> Know More </Link>
          </div>
        </div>
        <div className="solution-card">
          <div className="solution-image">
            <img src={img5} alt="Multi-Group Collaboration" />
          </div>
          <div className="solution-content">
            <h1>Practical Conversations for Meaningful Outcomes</h1>
            <p> Empowering teams to communicate with clarity and impact—through custom solutions, negotiation frameworks, and system mapping tools that turn collaboration into tangible results. </p>
            <Link to="/services" className="btn"> Know More </Link>
          </div>
        </div>
      </div>
      <div className="home-container">

        <div className="testimonials-container">
          <h2>What Our Clients Say</h2>
          <div className="testimonial-slide">
            <p className="testimonial-text">
              “{testimonials[currentIndex].text}”
             
            </p>
            <h4 className="testimonial-author">— {testimonials[currentIndex].author}</h4>
          </div>
          <div className="testimonial-dots">
            {testimonials.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentIndex ? "active" : ""}`}
                onClick={() => setCurrentIndex(index)}
              ></span>
            ))}
          </div>
        </div>
      </div>
      <div className="tools-section">
        <div className="tools-header">
          <h1>Connect: Our Social Feed</h1>
        </div>
        <div className="social-media-links">

          <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook Link"> <FontAwesomeIcon icon={faFacebookF} /> Facebook </a>

          <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" aria-label="Twitter Link"> <FontAwesomeIcon icon={faTwitter} /> Twitter </a>

          <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram Link"> <FontAwesomeIcon icon={faInstagram} /> Instagram </a>

          <a href="https://www.linkedin.com/company/rtstechsol/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn Link"> <FontAwesomeIcon icon={faLinkedinIn} /> LinkedIn </a>

        </div>
      </div>

      <div className="blue-card">
        <div className="card-content">
          <div className="card-text">
            <h1>Transform Your Business with Us</h1>
            <p> We help companies achieve growth through digital transformation, innovative strategies, and scalable technology solutions. </p>
            <button href="/">Learn More</button>
          </div>
          <div className="card-image">
            <img src={card} alt="Business Growth" />
          </div>
        </div>
      </div>
      <div className="newsletter-main">
        <div className="newsletter-container">
          <div className="newsletter-text">
            <h1>Stay Updated with Our Latest News</h1>
            <p> Subscribe to our newsletter and get updates on our latest technologies, insights, and announcements straight to your inbox. </p>
          </div>

          <div className="newsletter-card">
            <h2>Stay Updated - Subscribe to Our Newsletter</h2>
            <form onSubmit={handleSubscribe}>
              <input type="email" placeholder="Enter your email address" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={isLoading} />
              <button type="submit" disabled={isLoading}>
                {isLoading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
            {message && <p className="subscription-message">{message}</p>}
          </div>

        </div>

        <header className="client-trust-header">
          {/* Title and Intro Text */}
          <h1 className="client-trust-title">Trusted by Industry & Academia</h1>
          <p className="client-trust-intro-text">
            Our elite client portfolio represents the pinnacle of global enterprise success. These industry leaders have chosen RTS TECHSOL to transform their workforce capabilities, demonstrating the trust and confidence that Fortune 500 companies place in our training excellence.
          </p>
        </header>

        {/* Client Logos Grid */}
        <div className="client-logos-grid">
          {clientLogos.map((logo, index) => (
            <div key={index} className="client-logo-item">

              <img src={logo.src} alt={logo.alt} className="client-logo-image" />
            </div>
          ))}
        </div>
        <div className="footer">
          <div className="footer-overlay">
            <div className="footer-container">
              <div className="footer-section">
                <p> +91 6301540477</p>
                <p> info@rtstechsol.com</p>
              </div>
              <div className="footer-section">
                <h1>RTS TechSol</h1>
                <ul>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/ourTeam">Our Team</Link></li>
                  <li><Link to="/contact">Careers</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                  <li><span>Privacy Policy</span></li>
                </ul>
              </div>
              <div className="footer-section">
                <h1>Solutions</h1>
                <ul>
                  <li><HashLink smooth to="/services#TECH">Transforming Enterprise Talent</HashLink></li>
                  <li><HashLink smooth to="/services#leader">Leadership Development</HashLink></li>
                  <li><HashLink smooth to="/services#Advisory">Advisory & Consulting</HashLink></li>
                  <li><HashLink smooth to="/services#Train">Technology Trainings</HashLink></li>
                  <li><HashLink smooth to="/services#Domain">Domain-Specific</HashLink></li>
                  <li><HashLink smooth to="/services#Talent">Talent Acquisition</HashLink></li>
                  <li><HashLink smooth to="/services#Cloud">Cloud Labs</HashLink></li>


                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
